import { render, staticRenderFns } from "./ServiceDeskBlock.vue?vue&type=template&id=2eeef5a6&scoped=true&"
import script from "./ServiceDeskBlock.vue?vue&type=script&lang=js&"
export * from "./ServiceDeskBlock.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDeskBlock.vue?vue&type=style&index=0&id=2eeef5a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eeef5a6",
  null
  
)

component.options.__file = "ServiceDeskBlock.vue"
export default component.exports